export enum ROUTE_COMMUNITY {
  EXPLORE = 'community-explore',

  URI_HOME = 'community-thread_id-index',
  URI_FACETS_CONTENT = 'community-thread_id-index-content_type',
  URI_FACETS_DT_IDEA = 'community-thread_id-index-dt-idea-:derived_type_id',
  URI_FACETS_DT_POST = 'community-thread_id-index-dt-post-:derived_type_id',
  URI_FACETS_IDEA = 'community-thread_id-index-idea',
  URI_FACETS_MEDIA = 'community-thread_id-index-media',
  URI_FACETS_QUESTION = 'community-thread_id-index-question',
  URI_FACETS_WEDO = 'community-thread_id-index-wedo',
  URI_FACETS_WIKI = 'community-thread_id-index-wiki',
  URI_FACETS_EXPERIENCE = 'community-thread_id-index-facet-:facet_uri',
  URI_MEMBERS = 'community-thread_id-members',
  URI_SETTINGS = 'community-thread_id-settings',
  URI_REPORTS = 'community-thread_id-reports',
  URI_STATISTICS = 'community-thread_id-statistics',
  URI_RECYCLE_BIN = 'community-thread_id-recycle-bin',
  URI_TERMS_OF_USE = 'community-thread_id-terms-of-use',
}
